<template>
  <div style="width: 100%">
    <div class="list-usaha">
      <div class="list-usaha-content list-usaha-content__title" style="margin-bottom: 0 !important">
        <p v-for="(table, index) in tables" :key="index" :class="table.css">
          {{ table.name }}
        </p>
      </div>
      <div v-for="(list, index) in listInput" :key="index">
        <div v-if="showForm(list.t_resiko, tingkatResiko) ||
          showForm(list.name, tingkatResiko)
          ">
          <div class="list-usaha-content" style="margin-top:5px">
            <p v-for="(table, i) in tables" :key="i" :class="table.css">
              <span v-if="table.input">
                <input style="width: 90%" :type="table.type" v-model="$store.state[storeName][list.inputStore]"
                  v-if="table.type == 'text'" :disabled="disabled" />
                <select style="width:90%;height:100%" name="" id="" v-model="$store.state[storeName][table.optionModel]"
                  v-if="table.type == 'select'" :disabled="disabled">
                  <option style="text-align:center" v-for="(option, index) in list[table.optionList]" :value="option.id"
                    :key="index">{{ option.name }}</option>
                </select>
              </span>

              <span v-else>{{ list[table.type] }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BlockLabelGray from './label/blockLabel-gray.vue'
export default {
  props: [
    'label',
    'isRequired',
    'tables',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'listInput',
    'disabled',
  ],
  components: { BlockLabelGray },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {
    tingkatResiko() {
      return this.$tingkatResikoValue()
    },
  },
  methods: {
    showForm(origin, value) {
      value = value.toLowerCase()
      origin = origin && origin.toLowerCase()

      if (value == origin) return true

      return false
    },
  },
}
</script>
